<div [formGroup]="form">
    <mat-form-field *ngIf="paymentModel" appearance="fill" class="w-full">
        <mat-label>Modelo de Pago</mat-label>
        <mat-select formControlName="paymentModelId" placeholder="Seleccione un modelo de pago" multiple>

            <!-- <mat-select-trigger>
                {{ getDisplayValue(paymentModelList, form.get('paymentModelId')?.value, "name")}}
            </mat-select-trigger> -->

            <mat-option *ngFor="let item of paymentModelList" [value]="item">
                {{ getTypeLabel(item) }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="paymentTypeList?.length" appearance="fill" class="w-full">
        <mat-label>Tipo de Pago</mat-label>
        <mat-select formControlName="paymentTypeId" placeholder="Seleccione un tipo de pago" multiple>

            <mat-select-trigger>
                {{ getDisplayValue(paymentTypeList, form.get('paymentTypeId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchPaymentType" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar tipo de pago..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterPaymentType($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let paymentType of filteredPaymentTypeList" [value]="paymentType.code">
                {{ paymentType.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="paymentMethodList?.length" appearance="fill" class="w-full">
        <mat-label>Método de Pago</mat-label>
        <mat-select formControlName="paymentMethodId" placeholder="Seleccione un método de pago" multiple>

            <mat-select-trigger>
                {{ getDisplayValue(paymentMethodList, form.get('paymentMethodId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchPaymentMethod" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar método de pago..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterPaymentMethod($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let paymentMethod of filteredPaymentMethodList" [value]="paymentMethod.code">
                {{ paymentMethod.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="bankList?.length" appearance="fill" class="w-full">
        <mat-label>Banco</mat-label>
        <mat-select formControlName="bankId" placeholder="Seleccione un banco" multiple>

            <mat-select-trigger>
                {{ getDisplayValue(bankList, form.get('bankId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchBank" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar banco..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterBank($event)">
                </ngx-mat-select-search>
            </mat-option>
                <mat-option *ngFor="let bank of filteredBankList" [value]="bank.code">
                    <div class="text-sm uppercase leading-tight">
                        <div>
                            <b class="f-9" *ngIf="getCode(bank) as code">{{ code }}</b>
                        </div>
                        {{ bank.name }}
                    </div>
                </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="paymentConditionList?.length" appearance="fill" class="w-full">
        <mat-label>Condición de Pago</mat-label>
        <mat-select formControlName="paymentConditionId" placeholder="Seleccione un Condición de Pago" multiple>

            <mat-select-trigger>
                {{ getDisplayValue(paymentConditionList, form.get('paymentConditionId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchPayCondition" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar una Condición de Pago..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterPayCondition($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let payCondition of filteredPayConditionList" [value]="payCondition.id">
                {{ payCondition.name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

</div>